import { useScrollReveal } from "@/hooks/useScrollReveal";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="depoimentos" className="py-20 md:py-32 bg-background-100">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 md:px-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <p className="flex items-center justify-center gap-3 font-label text-[11px] md:text-xs uppercase tracking-[0.3em] text-primary-600 mb-6">
            <span className="w-10 h-[1px] bg-primary-500/60" />
            Depoimentos
            <span className="w-10 h-[1px] bg-primary-500/60" />
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-7">
            O que nossas{" "}
            <span className="italic font-normal text-foreground-400">clientes</span>
            <br />
            dizem sobre nós
          </h2>
          <div className="inline-flex items-center gap-2.5 bg-background-50 border border-background-200 rounded-full px-5 py-2.5">
            <i className="ri-google-fill text-primary-600 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-label uppercase tracking-[0.14em] text-foreground-600">
              Avaliações reais no Google
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <article
              key={t.id}
              className={`bg-background-50 border border-background-200 rounded-2xl p-6 md:p-7 flex flex-col transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="flex items-center gap-0.5 text-primary-500 mb-4">
                {[0, 1, 2, 3, 4].map((star) => (
                  <i
                    key={star}
                    className="ri-star-fill text-sm w-4 h-4 flex items-center justify-center"
                  ></i>
                ))}
              </div>
              <p className="font-heading text-base md:text-lg text-foreground-800 leading-relaxed flex-1 mb-6">
                {t.text}
              </p>
              <div className="pt-4 border-t border-background-200">
                {t.service && (
                  <p className="text-[11px] font-label uppercase tracking-[0.12em] text-primary-600">
                    {t.service}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}